import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { Button, Icon } from '@/components/ui';

/**
 * « Nouvelle version disponible » : l'utilisateur peut l'activer tout de suite ; sinon elle
 * s'applique d'elle-même au prochain changement de page — jamais au milieu d'une saisie, ni
 * quand le fidèle bascule vers ses SMS ou l'application Wave.
 */
export function UpdateToast() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      // Vérifie les mises à jour toutes les heures (sessions longues).
      if (registration) setInterval(() => void registration.update(), 3_600_000);
    },
  });

  const { pathname } = useLocation();
  // Page où la nouvelle version a été détectée : la quitter déclenche la mise à jour.
  const shownOn = useRef<string | null>(null);
  useEffect(() => {
    if (!needRefresh) return;
    if (shownOn.current === null) shownOn.current = pathname;
    else if (shownOn.current !== pathname) void updateServiceWorker(true);
  }, [needRefresh, pathname, updateServiceWorker]);

  if (!needRefresh && !offlineReady) return null;
  return (
    <div role="status" className="fixed inset-x-0 bottom-[calc(76px+env(safe-area-inset-bottom))] z-50 mx-auto max-w-lg px-4">
      <div className="flex items-center gap-3 rounded-2xl bg-brand-900 p-4 text-white shadow-xl">
        <p className="flex-1 text-sm">{needRefresh ? 'Nouvelle version disponible.' : 'L’application fonctionne désormais hors ligne.'}</p>
        {needRefresh ? (
          <Button size="sm" variant="gold" onClick={() => void updateServiceWorker(true)}>
            Mettre à jour
          </Button>
        ) : (
          <Button size="sm" variant="ghost" className="text-white hover:bg-white/10" onClick={() => setOfflineReady(false)}>
            OK
          </Button>
        )}
        {needRefresh && (
          <button className="px-2 text-white/70" aria-label="Plus tard" onClick={() => setNeedRefresh(false)}>
            <Icon name="close" size={18} />
          </button>
        )}
      </div>
    </div>
  );
}
